import React, { useId } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

/**
 * Lista desplegable de opciones fijas ("Ordenados por", estado, etc.).
 * No lleva opción vacía: el valor inicial lo decide quien la usa.
 *
 * @param {object} props
 * @param {string} props.label
 * @param {string|number} props.value
 * @param {(valor: string|number) => void} props.onChange
 * @param {{ valor: string|number, nombre: string }[]} props.opciones
 */
export const SelectorOpciones = ({ label, value, onChange, opciones }) => {
  const id = useId();

  return (
    <FormControl fullWidth sx={{ textAlign: "left" }}>
      <InputLabel id={`${id}-label`}>{label}</InputLabel>
      <Select
        labelId={`${id}-label`}
        id={id}
        value={value}
        label={label}
        onChange={(e) => onChange(e.target.value)}
        sx={{ textAlign: "left" }}
      >
        {opciones.map((item) => (
          <MenuItem key={item.valor} value={item.valor}>
            {item.nombre}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
